export default "__VITE_ASSET__CdwYbrQ6__"